import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertTriangle, CheckCircle2, Info, LucideAngularModule, X } from 'lucide-angular';

export type AlertType = 'success' | 'error' | 'warning' | 'info' | 'danger' | 'primary' | 'secondary';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  standalone: true,
  imports: [CommonModule, LucideAngularModule]
})
export class AlertComponent {
  @Input() type: AlertType = 'info';
  @Input() dismissible = false;
  @Input() showIcon = true;
  @Input() message?: string;

  dismissed = false;

  get alertClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-green-50 border-green-200 text-green-800';
      case 'error':
      case 'danger':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200 text-yellow-800';
      case 'info':
        return 'bg-blue-50 border-blue-200 text-blue-800';
      case 'primary':
        return 'bg-indigo-50 border-indigo-200 text-indigo-800';
      case 'secondary':
        return 'bg-gray-50 border-gray-200 text-gray-800';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  }

  get icon() {
    switch (this.type) {
      case 'success':
        return CheckCircle2;
      case 'error':
      case 'danger':
        return AlertTriangle;
      case 'warning':
        return AlertTriangle;
      case 'info':
      case 'primary':
      case 'secondary':
      default:
        return Info;
    }
  }

  get iconClass(): string {
    switch (this.type) {
      case 'success':
        return 'text-green-500';
      case 'error':
      case 'danger':
        return 'text-red-500';
      case 'warning':
        return 'text-yellow-500';
      case 'info':
        return 'text-blue-500';
      case 'primary':
        return 'text-indigo-500';
      case 'secondary':
        return 'text-gray-500';
      default:
        return 'text-blue-500';
    }
  }

  dismiss(): void {
    this.dismissed = true;
  }

  // Icons
  protected readonly XIcon = X;
}
